import styled from 'styled-components'

const StyledStakingFooter = styled.div`
  @media screen and (max-width: 640px) {
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    background: white;
    padding: 10px;
    bottom: 0;
    box-shadow: 0 -0.5px 0 0 rgba(0, 0, 0, 0.2);
    z-index: 1;
  }
`
const StyledStakingContainer = styled.div`
  display: flex;
  padding-bottom: env(safe-area-inset-bottom);
`

const StyledFooterButton = styled.button`
  background: rgba(95, 77, 188, 0.2);
  color: #5f4dbc;
  width: 100%;
  font-size: 15px;
  padding: 9px 0;
  border-radius: 42px;
  border: 0;
  outline: none;
  &.primary {
    background: #5f4dbc;
    color: #fff;
  }
  &.inline {
    flex: 1;
  }
  &:not(:first-of-type) {
    margin-left: 6px;
  }
  .loading {
    width: 24px;
    height: 24px;
    margin: 0 9px;
    animation: rotating 2s linear infinite;
  }
  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
export { StyledStakingFooter, StyledStakingContainer, StyledFooterButton }
